import {Button, Dropdown, Modal, Popconfirm, Switch, Tooltip} from 'antd';
import React, {useEffect, useMemo, useState} from 'react';

import {brandConfig, isCampaignAcquisition, LockIcon, STRINGS} from '../../libs/ui/src';

import {IntercomService} from '../../services';

export const CampaignsLeftActions = ({
  client,
  campaigns,
  showInitialReviewButton,
  onCreateCampaign,
  requestInitialReview,
  handleChangeRunState,
  settings,
  setSettings,
  isTrial,
}: any) => {
  const [showToggleCampaignsTip, setShowToggleCampaignsTip] = useState(true);

  useEffect(() => {
    const showNewClientRunCampaignsTip = settings?.showNewClientRunCampaignsTip;
    const isSomeCampaignWasRunning = campaigns.some(c => c?.stats?.reach);
    const isNewCampaignReady = campaigns.some(
      c => c?.selectedUser && !c?.selectedUser?.error_code && c?.actions?.length
    );
    setShowToggleCampaignsTip(
      showNewClientRunCampaignsTip && !client.enabled && isNewCampaignReady && !isSomeCampaignWasRunning
    );
  }, [campaigns]);
  const runBotTooltip = useMemo(() => {
    if (!client.active) {
      if (brandConfig.isLeadoku) return STRINGS.info_demo_leadoku;
      return STRINGS.info_demo;
    }
    return '';
  }, [client]);
  const checkAndCreateCampaign = params => {
    if (params.key === 'acquisition_inmail') {
      const hasAcquisitionCampaigns = campaigns.find(campaign => isCampaignAcquisition(campaign));
      if (hasAcquisitionCampaigns) {
        onCreateCampaign(params);
      } else {
        Modal.confirm({
          title: 'Are you sure you want to start with an inmail campaign?',
          content:
            'We recommend starting with Acquisition campaigns, based on our experience, they generate twice as many responses as inMail campaigns.',
          onOk: () => onCreateCampaign(params),
          onCancel: undefined,
        });
      }
    } else {
      onCreateCampaign(params);
    }
  };

  const menuItems = [
    {
      key: 'acquisition',
      className: campaigns.length === 0 ? 'first_campaign_creation' : '',
      style: { fontWeight: 'bold' },
      label: 'Acquisition',
    },
    {
      key: 'retention',
      className: campaigns.length === 0 ? 'first_campaign_creation' : '',
      disabled: !client.premium_feature,
      style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontWeight: 'bold' },
      label: (
        <>
          Nurturing
          {!client.premium_feature && (
            <LockIcon
              message={STRINGS.message_unlock_feature}
              onClick={() =>
                IntercomService.trackIntercomEvent('retention_feature_request', true, !client.premium_feature)
              }
            />
          )}
        </>
      ),
    },
    ...(client.inmail_feature
      ? [
          {
            className: campaigns.length === 0 ? 'first_campaign_creation' : '',
            key: 'acquisition_inmail',
            label: 'Acquisition+ (inMail)',
          },
        ]
      : []),
    ...(client.dynamic_campaigns_feature
      ? [
          {
            key: 'dynamic_campaign',
            label: 'New Campaign (Beta)',
          },
        ]
      : []),
  ];

  return (
    <div className="campaigns-page__left-controls">
      <Dropdown
        trigger={['click']}
        placement="bottomLeft"
        menu={{ items: menuItems, onClick: checkAndCreateCampaign }}
      >
        <Button type="primary" size="large" disabled={isTrial}>
          New Campaign
        </Button>
      </Dropdown>
      {showInitialReviewButton && brandConfig.isGx && (
        <Button style={{marginLeft: '10px'}} type="primary" size="large" onClick={requestInitialReview}>
          Schedule a Demo
        </Button>
      )}
      <Popconfirm
        className="campaigns-page__toggle-tip"
        placement="bottomLeft"
        title={'Click here to run campaigns'}
        onConfirm={() => {
          setSettings({showNewClientRunCampaignsTip: false});
          setShowToggleCampaignsTip(false);
        }}
        okText="Ok"
        cancelButtonProps={{style: {display: 'none'}}}
        open={showToggleCampaignsTip}
      >
        <div className="campaigns-page__toggle-container">
          <div style={{minWidth: 50, display: 'inline-block'}}>{client.enabled ? 'Live' : 'Go Live'}</div>
          <Tooltip title={runBotTooltip}>
            <Switch
              disabled={!campaigns && !campaigns.length}
              checked={!!client.enabled}
              style={{marginLeft: '10px'}}
              onChange={handleChangeRunState}
            />
          </Tooltip>
        </div>
      </Popconfirm>
    </div>
  );
};
